export interface ISummaryState {
  totalItemsCount: number
}

export const initialState = (): ISummaryState => {
  return {
    totalItemsCount: 0
  }
}
